import type { ReactNode } from 'react';

interface Props {
  title: string;
  children: ReactNode;
  isLast?: boolean;
}

export const navSectionHeaderClassName = 'my-1 px-1 font-medium text-base text-secondary';

export default function ({ title, isLast = false, children }: Props) {
  return (
    <>
      <div className="">
        <div className={navSectionHeaderClassName}>{title}</div>
        <div className="flex flex-col gap-1">{children}</div>
      </div>
      {!isLast && <div className="my-2 h-[1px] border-b" />}
    </>
  );
}
